import React from "react";
import "./RecentAnswersSection.css";
import { RecentAnswer } from "winslow-core";
import AnswerCard from "../../common/AnswerCard";

interface RecentAnswersSectionProps {
  recentAnswers: RecentAnswer[];
}

const RecentAnswersSection: React.FC<RecentAnswersSectionProps> = ({
  recentAnswers,
}) => {
  return (
    <div className="cards-section">
      {recentAnswers.map((recentAnswer) => (
        <AnswerCard key={recentAnswer.id} recentAnswer={recentAnswer} />
      ))}
    </div>
  );
};

export default RecentAnswersSection;
